import { Alert } from '@ps/isp-web-component-library';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';
import { useDispatch } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { Dispatch } from '@swf/core/store';

import { isStakeError } from '../../../../../../../../utils/isStakeError';

import styles from './StakeError.scss';

const StakeError: React.FC<{ fieldName: string }> = ({ fieldName }) => {
  const dispatch = useDispatch<Dispatch>();
  const {
    input,
    meta: { error }
  } = useField(`${fieldName}.stakePerLine`, { subscription: { error: true } });

  if (!error || !isStakeError(error)) {
    return null;
  }

  const handleErrorButtonPointerDown = (event: React.PointerEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const newInputValue = String(error.value);

    input.onChange(newInputValue);

    dispatch.betSlip.updateStakeCursorPosition({
      selectionStart: newInputValue.length,
      selectionEnd: newInputValue.length
    });
  };

  const currencyValue = error.actionableValue ? (
    <button className={styles.button} onPointerDown={handleErrorButtonPointerDown} type="button">
      <CurrencyAmount value={error.value} dollarValue />
    </button>
  ) : (
    <CurrencyAmount value={error.value} dollarValue />
  );

  return (
    <Alert level="warning" variant="passive" className={styles.stakeError}>
      <div>
        <Translation
          {...error.translationTag}
          values={{
            0: currencyValue
          }}
        />
      </div>
    </Alert>
  );
};

export default StakeError;
